import styled from 'styled-components';
export const LineDivider = styled.div.attrs({
  id: 'LineDivider',
})`
  height: 1px;
  width: ${props => (props.width ? props.width : `100%`)};
  background-color: black;
`;
